var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_vm._m(0),_c('div',[_c('h5',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.start)+" to "+_vm._s(_vm.end))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-5"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('h5',[_vm._v("RECOMMENDATIONS")])])])
}]

export { render, staticRenderFns }